import { ElMessage, ElMessageBox } from 'element-plus';

export const message = (content, typeIndex) => {
	let type;
	switch (typeIndex) {
		case 1: type = 'success'; break;
		case 2: type = 'warning'; break;
		case 3: type = 'error'; break;
		default: break;
	}
	ElMessage({
		message: content,
		type: type,
		duration: 5 * 1000
	});
}

export const buyMessageFn = (text, price) => {
	const priceText = `<span style="color: var(--fontColor_16);font-weight: bold;">${price}</span>`;
	if (price === undefined) {
		message('价格无效', 2);
		return Promise.reject('价格无效');
	}
	return ElMessageBox.confirm(
		`是否消耗${priceText}积分${text ? ',' + text : ''}`,
		'提示',
		{
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning',
			dangerouslyUseHTMLString: true,
		}
	)
}
